import { forEach } from "lodash";


export default class Ajustadores {
    revisarCamasSeleccionadas(lista_camas, cama_inicio, cama_fin, metros_inicio, metros_fin) {
        /* Verificarorden de las camas */
        let inicio = +cama_inicio;
        let fin = +cama_fin;
        if (inicio > fin) {
            let temp = inicio;
            inicio = fin;
            fin = temp;
        }

        /* Crear un hash de camas para acceso rápido por número de cama */
        const hashCamas = {};
        const len = lista_camas.length;
        for (let i = 0; i < len; i++) {
            const cama = JSON.parse(JSON.stringify(lista_camas[i]));
            hashCamas[cama.cama] = cama;
        }

        const camas_reporte = {
            desbordantes: [],
            camas: {},
            metros_totales: 0,
        };

        for (let i = inicio; i <= fin; i++) {
            const cama = hashCamas[i];
            if (!cama) continue;
            let metros_a_ocupar = cama.total_metros;
            if (i === inicio) {
                metros_a_ocupar = metros_inicio;
            } else if (i === fin) {
                metros_a_ocupar = metros_fin;
            }

            const metros_libres = cama.total_metros - cama.ocupado_metros;
            if (metros_a_ocupar > metros_libres) {
                camas_reporte.desbordantes.push(`(Cama: ${cama.cama}, excedente: ${metros_a_ocupar - metros_libres} metros)`);
            }
            camas_reporte.camas[cama.cama] = {
                cama: cama.cama,
                cama_definida: cama.cama_definida,
                total_metros: cama.total_metros,
                ocupado_metros: cama.ocupado_metros + metros_a_ocupar,
                ocupado_porcentaje: cama.total_metros != 0 ? Math.round((cama.ocupado_metros + metros_a_ocupar) / cama.total_metros * 100) / 100 : 1
            }
            camas_reporte.metros_totales += metros_a_ocupar;
        }

        //agregamos los tuneles que las camas abarcan
        let tunelInicio = (cama_inicio - (cama_inicio % 4)) / 4;
        let tunelFin = (cama_fin - (cama_fin % 4)) / 4;


        let tunel = "";
        if (tunelInicio === tunelFin) tunel = `${tunelInicio + 1}`;
        else {
            for (let i = tunelInicio; i <= tunelFin; i++) tunel += (i + 1) + ",";
            tunel = tunel.slice(0, -1);
        }

        camas_reporte.tunel = tunel;
        camas_reporte.cama_inicio = cama_inicio;
        camas_reporte.cama_fin = cama_fin;
        return camas_reporte;
    }

    ajustarCamasRegistro = (registro) => {
        //Verificación y redondeo de los valores de las camas
        let cama_inicio = +registro.cama_inicio;
        let cama_fin = +registro.cama_fin;
        if (isNaN(cama_inicio) || isNaN(cama_fin)) return { estatus: false, msj: "Las camas deben ser números mayores a 0" };
        cama_inicio = Math.ceil(cama_inicio);
        cama_fin = Math.ceil(cama_fin);
        if (cama_inicio < 1 || cama_fin < 1) return { estatus: false, msj: "Las camas deben ser números mayores a 0" };

        //Verificación de que las camas no sean iguales y esten en orden correcto
        if (cama_inicio > cama_fin) {
            let temp = cama_inicio;
            cama_inicio = cama_fin;
            cama_fin = temp;
        }

        //agregamos los tuneles que las camas abarcan
        let tunelInicio = (cama_inicio - (cama_inicio % 4)) / 4;
        let tunelFin = (cama_fin - (cama_fin % 4)) / 4;


        let tunel = "";
        if (tunelInicio === tunelFin) tunel = `${tunelInicio + 1}`;
        else {
            for (let i = tunelInicio; i <= tunelFin; i++) tunel += (i + 1) + ",";
            tunel = tunel.slice(0, -1);
        }

        registro.tunel = tunel;
        registro.cama_inicio = cama_inicio;
        registro.cama_fin = cama_fin;
        return { estatus: true, registro };
    }

    //A partir del objeto de camas recibido extrae todas las valvulas y las agrupa en una sola lista
    extraerValvulas = (arregloCamas) => {
        let valvulas = [];
        let lenRanchos = (arregloCamas ?? []).length;
        for (let i = 0; i < lenRanchos; i++) {
            let lenValvulas = (arregloCamas[i].valvulas ?? []).length;
            for (let j = 0; j < lenValvulas; j++) {
                valvulas.push(this.calcular_bloques_camas_libres(arregloCamas[i].valvulas[j]));
            }
        }

        return valvulas;
    }

    //En una valvula agrega los grupos de camas libres, es decir, cama  a 13, 15 a 18 etc.
    calcular_bloques_camas_libres = (valvula) => {
        let bloques = [{ inicio: 0, fin: 0 }];
        let lenBloques = 0;
        let len = valvula.camas.length;
        for (let i = 0; i < len; i++) {

            if (this.metrosDisponiblesCama(valvula.camas[i], valvula.largo_cama) > 0) {
                //La valvula está libre, hay que verificar si ya se esta contando un bloque
                if (bloques[lenBloques].inicio === 0) bloques[lenBloques].inicio = i + 1;
            }
            else {
                //Si el bloque está ocupado y ya existe un bloque iniciado se concluye
                if (bloques[lenBloques].inicio !== 0) {
                    bloques[lenBloques].fin = i;
                    lenBloques++;
                    bloques.push({ inicio: 0, fin: 0 });
                }
            }
        }
        //Al terminar el ciclo, si hay un bloque abierto lo cerramos
        if (bloques[lenBloques].inicio !== 0) {
            bloques[lenBloques].fin = len;
        } else {
            //Si el bloque nunca arranó lo eliminamos
            bloques.pop();
        }
        valvula.bloquesLibres = bloques;
        return valvula;
    }

    metrosDisponiblesCama = (cama, largo) => {
        let metros = 0;
        let len = cama.length;
        for (let i = 0; i < len; i++) metros += cama[i].metros_utilizados;
        return largo - metros;
    }

    calcular_metros_ocupados_camas = (camas, largo) => {
        let ocupacion = [];
        let len = camas.length;
        for (let i = 0; i < len; i++) {
            ocupacion.push(this.calcular_metros_ocupados_cama(camas[i], largo));
        }
        return ocupacion;
    }

    calcular_metros_ocupados_cama = (cama, largo) => {
        let metros = 0;
        let len = cama.length;
        for (let i = 0; i < len; i++) metros += cama[i].metros_utilizados;
        let porcentaje = metros > largo ? 100 : largo > 0 ? (metros / largo) * 100 : 100;

        return { metros, porcentaje: +porcentaje.toFixed(2), disponible: largo > metros ? largo - metros : 0 };
    }
    //Busca en las camas de la valvula cuales son del registro que se esta consultando y las elimina para que al momento de editar un plan no de error de colición
    //y pueda mostrar las camas originales del plan
    eliminarCamasRegistro = (camas, planeacion_id) => {
        if (!planeacion_id) return camas;
        let len = camas.length;
        for (let i = 0; i < len; i++) {
            let cama = camas[i];
            let lenCama = cama.length;

            if (lenCama === 0) continue;
            let camaCorreccion = [];
            for (let j = 0; j < lenCama; j++) {
                if (cama[j].planeacion_campo_id !== planeacion_id) {
                    camaCorreccion.push(cama[j]);
                }
            }
            camas[i] = camaCorreccion;
        }
        return camas;
    }

    /**
     * utilizando los valores actuales de los ranchos y los nuevos registros que se acaban de recibir de la base de datos se agregan los valores de rencho seleccionados
     * @param {List} nuevos Registros que se acaban de recibir de la base de datos
     * @param {List} antiguos Antiguos registros que ya estaban en la tabla
     * @returns {List} Registros con el rancho seleccionado
     */
    agregarRanchoSeleccionadoARegistros = (nuevos = [], antiguos = []) => {
        let antiguosByid = {};
        antiguos.forEach(element => { antiguosByid[element.id] = element?.rancho ?? ""; });
        let nuevosConRancho = [];

        nuevos.forEach(element => {
            element.rancho = antiguosByid[element.id]?.rancho ?? "";
            nuevosConRancho.push(element);
        });
        return nuevosConRancho;
    }

    filtrarValvulasPorRancho = (rancho, valvulas) => {
        if (["", null, undefined].includes(rancho)) return valvulas;
        let valvulasFiltradas = [];
        valvulas.forEach(valvula => {
            if (valvula.rancho_id === +rancho) valvulasFiltradas.push(valvula);
        });
        return valvulasFiltradas;
    }
}